import { render } from "./px-matching-interest-tip.vue?vue&type=template&id=b36fb0c2&scoped=true&ts=true"
import script from "./px-matching-interest-tip.vue?vue&type=script&lang=ts"
export * from "./px-matching-interest-tip.vue?vue&type=script&lang=ts"

import "./px-matching-interest-tip.vue?vue&type=style&index=0&id=b36fb0c2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b36fb0c2"]])

export default __exports__